import script from "./BaseChips.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseChips.vue?vue&type=script&setup=true&lang=js"

import "./BaseChips.vue?vue&type=style&index=0&id=f8ccf7cc&lang=scss"

const __exports__ = script;

export default __exports__